/**
 * Operating system names used by device detection.
 * These values are returned by getOperatingSystem() and used throughout the app.
 */
export const OPERATING_SYSTEM = {
  ANDROID: 'Android',
  IOS: 'iOS',
  WINDOWS: 'Windows',
  MACOS: 'macOS',
  LINUX: 'Linux',
  UNKNOWN: 'Unknown OS',
} as const;

export type OperatingSystem = (typeof OPERATING_SYSTEM)[keyof typeof OPERATING_SYSTEM];

/**
 * Browser names used by browser detection.
 */
export const BROWSER = {
  CHROME: 'Chrome',
  SAFARI: 'Safari',
  FIREFOX: 'Firefox',
  EDGE: 'Edge',
  UNKNOWN: 'Unknown Browser',
} as const;

export type Browser = (typeof BROWSER)[keyof typeof BROWSER];
